// extracted by mini-css-extract-plugin
export default {"root":"PaidUserReturnModal__root--1iHLf","content":"PaidUserReturnModal__content--1DQMB","text":"PaidUserReturnModal__text--1m33g","discount":"PaidUserReturnModal__discount--2qE2K"};